import { render, staticRenderFns } from "./AdjustRoute.vue?vue&type=template&id=3a9489c4&scoped=true&"
import script from "./AdjustRoute.vue?vue&type=script&lang=js&"
export * from "./AdjustRoute.vue?vue&type=script&lang=js&"
import style0 from "./AdjustRoute.vue?vue&type=style&index=0&id=3a9489c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9489c4",
  null
  
)

export default component.exports